import { Navigate, Route } from "react-router-dom";
import ObepLegacyDetailRedirect from "./ObepLegacyDetailRedirect";

const useObepRoutes = () => (
  <>
    <Route path="/obep/:id" element={<ObepLegacyDetailRedirect />} />
    <Route path="/obep" element={<Navigate to="/academics/obep" replace />} />
  </>
);

export default useObepRoutes;
